// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { IChangeRequest } from "../../hooks";
import React, { useState } from "react";
import { AdminTemplate, TransactionApprovalListingTable, TransactionApprovalModal, TransactionDecisionsListingTable, TransactionSubmittedForApprovalListingTable } from "../../components";
import { Badge, Box, Stack, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import { GridRowId } from "@mui/x-data-grid";
import screenNames from "../../common/screenNames.json";
export const TransactionApproval = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [isOpen, setIsOpen] = useState(false);
  const [menuData, setMenuData] = useState<IChangeRequest>();
  const [tabValue, setTabValue] = useState(0);
  const [approvedCounter, setApprovedCounter] = useState(0);

  const tabStyle = isDesktop ? {
    flex: 1,
    fontSize: '1rem', // Masaüstü için varsayılan font boyutu,
    whiteSpace: 'normal',
    wordBreak: 'break-all',
  } : {
    flex: 1,
    fontSize: '0.7rem', // Mobil için daha küçük font boyutu
    whiteSpace: 'normal',
    wordBreak: 'break-all',
  };

  const handleAddButton = () => setIsOpen(true);

  const handleRowClick = (data: {
    id: GridRowId;
    row: IChangeRequest;
  }) => {
    setIsOpen(true);
    setMenuData(data.row);
  }



  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  function translateOperationMode(mode: string) {
    switch (mode) {
      case "UPDATE":
        return "Güncelleme";
      case "DELETE":
        return "Silme";
      case "ADD":
        return "Tanımlama";
      case "SendMoney":
        return "Para Gönderme";
      default:
        return "Bilinmiyor";
    }
  }


  const generateTitle = (menuData) => {
    const screenName = screenNames[menuData.operationCode] || menuData.operationCode;
    const action = translateOperationMode(menuData.operationMode); // burada değişiklik yaptık
    return `${screenName} / ${action}`; // Formatı burada güncelledik
  }

  return (
    <AdminTemplate headerProps={{
      headerTitle: 'Onay İşlemleri ', hideAddButton: true,
      hideDownloadButton: true,
      hideSearchBar: true
    }}>
      <Stack flex={1} p={2}>
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <Tabs centered value={tabValue} onChange={handleTabChange} sx={{
            flex: 1,
          '.MuiTabs-flexContainer': {
            flexDirection: isMobile ? 'column' : 'row',
          },
          '.MuiTabs-indicator': {
            display: isMobile ? 'none' : 'flex', // Mobilde gizle, diğer durumlarda göster
          },
          '.Mui-selected': {
            position: 'relative',
            '&::after': isMobile ? {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              borderBottom: '2px solid',
              borderColor: 'primary.main',
            } : {}
          }
        }}>
          <Tab
            sx={tabStyle}
            label={
              <div style={{ position: 'relative' }}>
                Onaya Gelen İşlemler
                {approvedCounter > 0 && (
                  <Badge
                    badgeContent={approvedCounter}
                    color="error"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    style={{ position: 'absolute', top: -3, right: -5, whiteSpace: 'nowrap' }}
                  />
                )}
              </div>
            }
          />
          <Tab sx={tabStyle} label="Onayladıklarım/Reddettiklerim" />
          <Tab sx={tabStyle} label="Onaya Gönderdiklerim" />

          </Tabs>
        </Box>

        {tabValue === 0 && <TransactionApprovalListingTable isMenuOpen={isOpen} onRowClick={handleRowClick} setApprovedCounter={setApprovedCounter} />}
        {tabValue === 1 && <TransactionDecisionsListingTable isMenuOpen={isOpen} onRowClick={handleRowClick} />}
        {tabValue === 2 && <TransactionSubmittedForApprovalListingTable />}
      </Stack>

      {isOpen && <TransactionApprovalModal menu={menuData} isOpen={isOpen} onClose={() => {
        setMenuData(undefined);
        setIsOpen(false)
      }} title={generateTitle(menuData)} />}
    </AdminTemplate>
  );
};
